import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const OlIcon = (props) => {
  return (
    /*    <svg
    className= {props.selected ? "svgEditorSelected": "svgEditor"}
    height="20"    
    width="20">  
    <rect x="3" y="4" width="1" height="1" rx="0"/> 
    <rect x="8" y="4" width="7" height="1" rx="0"/>  

    <rect x="3" y="7" width="2" height="1" rx="0"/>      
    <rect x="8" y="7" width="7" height="1" rx="0"/>  

    <rect x="3" y="10" width="1" height="1" rx="0"/>
    <rect x="5" y="10" width="1" height="1" rx="0"/>    
    <rect x="8" y="10" width="7" height="1" rx="0"/> 

    <rect x="3" y="13" width="1" height="1" rx="0"/> 
    <rect x="5" y="13" width="2" height="1" rx="0"/>       
    <rect x="8" y="13" width="7" height="1" rx="0"/>    
  </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="9.000000pt" height="9.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M0 4585 l0 -135 135 0 135 0 0 -405 0 -405 135 0 135 0 0 540 0 540
-270 0 -270 0 0 -135z"/>
<path d="M1350 4180 l0 -270 1885 0 1885 0 0 270 0 270 -1885 0 -1885 0 0
-270z"/>
<path d="M0 2965 l0 -135 241 -2 240 -3 -240 -280 -240 -280 -1 -122 0 -123
405 0 405 0 0 135 0 135 -241 2 -242 3 242 282 241 281 0 121 0 121 -405 0
-405 0 0 -135z"/>
<path d="M1350 2560 l0 -270 1885 0 1885 0 0 270 0 270 -1885 0 -1885 0 0
-270z"/>
<path d="M0 1345 l0 -135 270 0 270 0 0 -65 0 -65 -135 0 -135 0 0 -135 0
-135 135 0 135 0 0 -70 0 -70 -270 0 -270 0 0 -135 0 -135 405 0 405 0 0 540
0 540 -405 0 -405 0 0 -135z"/>
<path d="M1350 940 l0 -270 1885 0 1885 0 0 270 0 270 -1885 0 -1885 0 0 -270z"/>
</g>
</svg>


  );
};

export default OlIcon;
